import { JsonPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router,NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import {KeycloakService,KeycloakOptions} from 'keycloak-angular';
import { AuthService } from '../api-services/Auth/auth.service';
import { environment as env, environment } from 'src/environments/environment';
import { PreviousRouterService } from '../api-services/previous-route/previous-router.service';
import { ProfileService } from '../api-services/profile/profile.service';
import { keyService } from '../api-services/keycloak/service/key.service';
import { KeycloakProfile } from 'keycloak-js';
import * as logoPath from '../../assets/json/img.json';
import * as appConstants from '../../assets/json/applicationConstants.json';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  brandData = appConstants?.commonAppConstants?.brandData;
  public loggedIn: boolean = false;
  loggedUser:string[]
  public userProfile: KeycloakProfile = {};
  imgPath:any = logoPath;
  userdetails: any;
  previousUrl: string = null;
  currentUrl: string = null;
  secCountryID=1
  points:any =0;
  member_role: any;
  doctor_role: any;
  ayurAdmin_role: string;
  accessUsers:Array<string>=['member','doctor','AyurwayAdmin'];
  checkUserRole:boolean;
  constructor(public router: Router, private authService: AuthService ,private urlService:PreviousRouterService,
    private memberPts:ProfileService,private kc:KeycloakService,private login_service:keyService  ) {
      //console.log("brandData",brandData.logoUrl)
     }
     wellnessUrl=env.ahyushUrl+'/login';
  //baseUrl =  env.ahyushLoginUrl;
 async ngOnInit():Promise< void> {
   
    this.loggedIn = await this.login_service.isLoggedIn();
    if (this.loggedIn) {
        this.userProfile = await this.login_service.loadUserProfile();
        this.loggedUser = this.login_service.getRoles();
        
        this.loggedUser.forEach(ele =>{
          if(ele =='member'){
            this.member_role =ele
          }else if(ele =='doctor'){
            this.doctor_role = ele
          }else if(ele =='AyurwayAdmin'){
            this.ayurAdmin_role =ele
          }
        });
    };
    this.authService.setCountryId(this.secCountryID);
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.url;
      this.urlService.setPreviousUrl(this.previousUrl);
    });

    this.authService.getUpdateName().subscribe(async(token:any) => {
      if (token) {
        this.userProfile = token
        
      }    
    });
  };

 

 test(){
   this.login_service.login()
 }

  selectCountry(){
    this.authService.setCountryId(this.secCountryID);
  }

  loggedOut() {
    this.login_service.logout();
    // this.authService.clearToken();
    // this.urlService.clearUrl();
    this.router.navigate(['/products']);
  };

  getPointsmember(){
    this.memberPts.getMemberProfile().subscribe(res =>{
      let memberDetails:any =res; 
      this.points = memberDetails.memberPoints != null? memberDetails.memberPoints.availablePoint:this.points
      // this.points =(memberDetails.memberDetails.rewardPoints)?memberDetails.memberDetails.rewardPoints:this.points;
    })
  }
}
